const baggageDictionary = require('./dictionaries/bags');
const commonDictionary = require('./dictionaries/common');
const baggageOptionsCollection = require('../../modules/collections/baggages_row_options').getInstance();
const baggageCollectionBuilder = require('../../modules/builders/baggages').getInstance();
const checkedBagsOneClickUtils = require('components/bags_and_seats/utils/checked_bags_one_click');

const Tracking = require('./tracking_base');

const BAGGAGE_SELECTION_CTA = {
    click: 'click',
    change: 'change',
    remove: 'remove',
    back: 'back',
    loadMore: 'load-more',
};

const BAGGAGE_SELECTION_LABELS = {
    select: 'select',
    selectOneClick: 'selectOneClick',
    moreOptionsOneClick: 'moreOptionsOneClick',
    select_extra: 'select_extra',
    select_option: 'select_option',
    change_autoselection: 'change_autoselection',
    remove: 'remove',
    close: 'close',
    continuance: 'continuance',
};

let instance;
const ACTION_KEY = 'baggage';

class BaggageTracking extends Tracking {
    constructor() {
        const dictionary = Odigeo._.merge({}, commonDictionary, baggageDictionary);
        super(dictionary, ACTION_KEY);
    }

    trackBaggageSelection(params, label, clickAction) {
        if (clickAction) {
            params.click = clickAction;
        }

        this.trackEvent({
            action: {
                name: 'selection',
                params: {
                    name: ACTION_KEY,
                },
            },
            label: {
                name: label,
                params,
            },
        });
    }

    getMaxdsc({isPrimeView, discountPercentage, discountAmount}, merchandisingDiscountPercentage) {
        if (isPrimeView) {
            return discountAmount > 0 ? `${discountAmount}-abs` : `${discountPercentage}-per`;
        }

        return `${merchandisingDiscountPercentage}-per`;
    }

    trackBaggageContinuance() {
        const selectedBags = baggageOptionsCollection.selectedPieces;
        const includedBags = baggageOptionsCollection.includedPieces;
        const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')) || {};
        const adultsNumber = searchParameters.numAdults || 0;
        const childNumber = searchParameters.numChildren || 0;
        const auto = +baggageCollectionBuilder.doBaggageAllowAutoselection();
        const primeInfo = baggageOptionsCollection.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const pax = adultsNumber + childNumber;
        const prime = isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na';
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        const maxdsc = this.getMaxdsc(primeInfo, merchandisingDiscountPercentage);
        const sav = Math.floor(baggageOptionsCollection.getPrimeSavedAmount());
        const params = {
            num_bags: {
                selectedBags,
                includedBags,
            },
            auto,
            pax,
            prime,
            maxdsc,
            sav,
            sce: checkedBagsOneClickUtils.__isInScope__ ? 'oc' : 'dc',
        };

        this.trackEvent({
            action: {
                name: 'continuance',
                params: {
                    name: ACTION_KEY,
                },
            },
            label: {
                name: BAGGAGE_SELECTION_LABELS.continuance,
                params,
            },
        });
    }

    onClick(params) {
        this.trackBaggageSelection(params, BAGGAGE_SELECTION_LABELS.select, BAGGAGE_SELECTION_CTA.click);
    }

    onClickOneClickMoreOptions(params) {
        this.trackBaggageSelection({...params, name: 'baggage-widget'}, BAGGAGE_SELECTION_LABELS.moreOptionsOneClick, BAGGAGE_SELECTION_CTA.loadMore);
    }

    onClickOneClickOption(params) {
        this.trackBaggageSelection({...params, name: 'baggage-option'}, BAGGAGE_SELECTION_LABELS.selectOneClick, BAGGAGE_SELECTION_CTA.click);
    }

    onChange(params) {
        this.trackBaggageSelection(params, BAGGAGE_SELECTION_LABELS.change_autoselection, BAGGAGE_SELECTION_CTA.change);
    }

    onClickExtra(params) {
        this.trackBaggageSelection(params, BAGGAGE_SELECTION_LABELS.select_extra, BAGGAGE_SELECTION_CTA.click);
    }

    onClickOption(params) {
        this.trackBaggageSelection(params, BAGGAGE_SELECTION_LABELS.select_option, BAGGAGE_SELECTION_CTA.click);
    }

    onRemove(params) {
        const removeParams = Object.assign(
            {},
            params,
            {sce: checkedBagsOneClickUtils.__isInScope__ ? 'oc' : 'dc'},
        );
        this.trackBaggageSelection(removeParams, BAGGAGE_SELECTION_LABELS.remove, BAGGAGE_SELECTION_CTA.remove);
    }

    onCloseSelector(params) {
        this.trackBaggageSelection(params, BAGGAGE_SELECTION_LABELS.close);
    }

    trackBaggagePaxContinuance() {
        this.trackBaggageContinuance('pax');
    }
    trackBaggagePayContinuance() {
        this.trackBaggageContinuance('pay');
    }

    onLoad(params) {
        this.trackEvent({
            action: {
                name: 'on_load_widgets',
            },
            label: {
                name: 'loaded',
                params: {name: 'baggage-widget_loaded'},
            },
        });
        this.trackEvent({
            action: {
                name: 'on_load_widgets',
            },
            label: {
                name: 'loadedAllInfo',
                params,
            },
        });
    }
}

module.exports = BaggageTracking;
module.exports.getInstance = () => {
    if (Odigeo._.isUndefined(instance)) {
        instance = new BaggageTracking();
    }

    return instance;
};
